/* eslint-disable import/order */
import classNames from "classnames"
import React, { useContext, useEffect, useState } from "react"

import {
  useInitSignupReminder,
  useSignupReminderStore,
} from "../../cart/reminder"
import { CartContext } from "../../cart/store"

import PillButton from "@components/elements/V2/Buttons/PillButton"
import GatsbyStoryblokImage from "@components/elements/V2/GatsbyStoryblokImage"
import CloseIcon from "@components/elements/V2/Icons/CloseIcon"
import Section from "@components/elements/V2/Section"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { localStorageAvailable } from "../../utils/shop"
import { getCookie } from "../../utils/analytics"

const ReminderBanner = () => {
  const [isClosed, setIsClosed] = useState(false)
  const cartContext = useContext(CartContext)
  const initSignupReminder = useInitSignupReminder()
  const { isReminderBannerVisible, pendingSignupOwnerFirstName } =
    useSignupReminderStore()

  const pendingSignupId = localStorageAvailable()
    ? getCookie("pending_signup_id")
    : undefined

  useEffect(() => {
    if (pendingSignupId) {
      initSignupReminder({ pendingSignupId })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!pendingSignupId || !isReminderBannerVisible) {
    return null
  }

  const firstCartItemImage =
    cartContext?.products && cartContext.products.length > 0
      ? typeof cartContext.products[0].image === "string"
        ? cartContext.products[0].image
        : cartContext.products[0].image?.filename
      : null

  return (
    <Section
      className={classNames(
        "flex min-h-64 flex-row gap-12 bg-charcoal py-12 sm:items-center sm:gap-16",
        {
          hidden: isClosed,
        }
      )}
    >
      {firstCartItemImage && (
        <div className="mt-1 flex h-48 min-w-48 rounded-[4px] bg-black sm:mt-0">
          <GatsbyStoryblokImage
            image={firstCartItemImage}
            alt={`${cartContext.products[0].name} image`}
            height={48}
            width={48}
          />
        </div>
      )}
      <div className="flex w-full flex-col justify-between gap-10 sm:flex-row sm:gap-x-24">
        <div className="flex flex-col gap-y-4 md:gap-0">
          <div className="flex items-center justify-between">
            <Typography
              text={`Every sale adds up${pendingSignupOwnerFirstName ? `, ${pendingSignupOwnerFirstName}` : ""}`}
              size="body-sm"
              font="grotesk"
              weight="medium"
              color={Color.White}
            />
            <div className="h-12 w-12 cursor-pointer sm:hidden">
              <CloseIcon
                width="12px"
                height="12px"
                hideBorder
                strokeWidth="2"
                strokeColor={Color.White}
                onClick={() => setIsClosed(true)}
              />
            </div>
          </div>
          <Typography
            text="200K+ businesses are selling with Yoco. Join them and grow your sales today."
            size="body-sm"
            font="grotesk"
            weight="book"
            color={Color.White}
            className="opacity-80"
          />
        </div>
        <div className="flex items-center gap-16">
          <PillButton
            style="bordered"
            size="small"
            color={Color.Blue}
            text="Start selling"
            hideIcon
            linkUrl={`${process.env.GATSBY_SHOP_SIGNUP_URL}/${pendingSignupId}/continue`}
          />
          <div className="hidden h-24 w-24 cursor-pointer sm:block">
            <CloseIcon
              width="24px"
              height="24px"
              hideBorder
              strokeWidth="2"
              strokeColor={Color.White}
              onClick={() => setIsClosed(true)}
            />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default ReminderBanner
